import React from 'react';
import { i18n } from 'core/i18n';
const { FormattedTextWithNamedVariables, extractNamedVariables, getNamedVariablesValues } = i18n;

export const getNamedVariables = (key, offerData) => {
    const namedVariables = extractNamedVariables(key);
    const namedVariablesValues = getNamedVariablesValues(namedVariables, offerData);
    return namedVariablesValues
}

const getTexts = (offer) => {
    const { accountConfig, accountDefinition, accountTexts = [] } = offer;

    return accountTexts.reduce((acc, text)=>{
        const { conditionConfig } = text;
        const namedVariablesContainer = {
            ...accountConfig,
            ...conditionConfig,
        }
        const keyName = `${accountDefinition.context}-${text.keyName}`
        const namedVariablesValues = getNamedVariables(keyName, namedVariablesContainer);

        acc[text.type].push(<FormattedTextWithNamedVariables value={keyName} namedVariables={namedVariablesValues} />)

        if(text.type === 'CONDITION'){
            const representativeExampleKey = `${accountDefinition.context}-${text.representativeExampleKey}`
            const representativeNamedVariablesValues = getNamedVariables(representativeExampleKey, namedVariablesContainer);

            acc.REPRESENTATIVE_EXAMPLE.push(<FormattedTextWithNamedVariables value={`${accountDefinition.context}-${text.representativeExampleKey}`} namedVariables={representativeNamedVariablesValues} />)
        }

        return acc
    }, {ADVANTAGE:[],CONDITION:[],REPRESENTATIVE_EXAMPLE:[]})
}

export const offersAccountsAdapter = (offers = {}) => {
    return getTexts(offers)
}
